import { Avatar, Box, Card, CardContent, Checkbox, Chip, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid2, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, Stack, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useGetClientDropdownQuery, useGetDashboardActivityCountQuery, useGetRecruiterTableDatasMutation, useGetTableDatasMutation } from "../../redux/dashboard/Dashboard.api"
import './dashboard.css'
import { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom'
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import NorthEastRoundedIcon from '@mui/icons-material/NorthEastRounded';
import CallReceivedRoundedIcon from '@mui/icons-material/CallReceivedRounded';
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import FilterListIcon from '@mui/icons-material/FilterList';
import { useEventDropDownQuery } from "../../redux/jobpostings/jobpostings.api"
import { useJobDescForParticularClientMutation } from "../../redux/reports/reports.api"
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from '../../assets/Icons/DownloadIcon'
import StatsIcon from "../../assets/Icons/StatisticsIcon"
import SearchIconLg from "../../assets/Icons/SearchIcon"
import ClearIcon from '@mui/icons-material/Clear';
import { Briefcase, Users, UserCheck, TrendingUp, TrendingDown, X } from "lucide-react"
import { createTheme, ThemeProvider, styled } from "@mui/material/styles"



const Dashboard = () => {
    const commonFilter = JSON.parse(localStorage.getItem('commonsearchfilter'))
    const [clientNameArr, setClientNameArr] = useState(commonFilter?.dashbord?.clientId || [])
    const [positionNameArr, setPositionNameArr] = useState(commonFilter?.dashbord?.positionId || [])
    const [eventTypeArr, setEventTypeArr] = useState(commonFilter?.dashbord?.eventId || [])
    const [positionDesc, setPositionDesc] = useState(commonFilter?.dashbord?.positionDesc || "")

    const theme = useTheme()
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))
    const navigate = useNavigate()
    const [clientName, setClientName] = useState("")
    const [dashboardCount, setDashboardCountDatas] = useState({})
    const [dashCount, setDashCount] = useState({})
    const [tableDatas, setTableDatas] = useState([])
    const [jobPostingArr, setJobPostingArr] = useState([])
    const [selectedClient, setSelectedClient] = useState([])
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(+localStorage.getItem("dashboardNewPage") || 1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [sortingColumn, setSortingColumn] = useState("createdDate")
    const [sortingDirection, setSortingDirection] = useState("DESC")
    const { Snackbar } = useContext(SnackbarContext)
    const [open, setOpen] = useState(false)
    const [triggerApi, setTriggerApi] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [statsOpen, setStatsOpen] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(null);
    const [dashBoardDisabled, setDashBoardDisabled] = useState(false)
    const [openClientName, setOpenClientName] = useState(false)
    const [openPositionTypes, setOpenPositionTypes] = useState(false)
    const [openEventName, setOpenEventName] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleStatsOpen = () => {
        // setStatsOpen(true)
        setOpenNew(true)
    }

    const handleStatsClose = () => {
        setStatsOpen(false)
    }

    const handlePageChange = (e, newPage) => {
        localStorage.setItem("dashboardNewPage", newPage)
        setPage(newPage)
        setTriggerApi(true)
    }

    // const handleRowsPerPageChange = (e) => {
    //     const value = +e.target.value
    //     setRowsPerPage(value)
    //     setPage(0)
    // }

    const { data: getClientDropdownlist } = useGetClientDropdownQuery()
    const { data: eventsDropdown } = useEventDropDownQuery()
    const [jobDescForParticularClient] = useJobDescForParticularClientMutation()
    // const [DashboardCount] = useGetDashboardCountMutation()
    const { data: dashboardActivityCount } = useGetDashboardActivityCountQuery()
    const [GridDatas] = useGetTableDatasMutation()
    const [RecruiterTableDatas] = useGetRecruiterTableDatasMutation()
    // const {
    //     noOfActivePost,
    //     noOfActiveClients,
    //     noOfActiveRecuiters,
    //     noOfActiveProfiles
    // } = dashboardCount?.response || {}

    const { Profile } = useSelector((state) => state.common)
    const userRole = Profile?.profile?.role

    useEffect(() => {
        if (dashboardActivityCount) {
            setDashCount(dashboardActivityCount?.data?.counts)
        }
    }, [dashboardActivityCount])

    const [uniqueClientName, setUniqueClientName] = useState([])
    useEffect(() => {
        const getJobPostingsData = async () => {
            try {
                const payload = {
                    clientIds: clientNameArr || []
                }
                const response = await jobDescForParticularClient(payload).unwrap()
                if (response?.status === 200) {
                    setJobPostingArr(response?.response || [])
                    const clientNameList = response?.response?.map((item) => item?.clientName) || [];
                    setUniqueClientName([...new Set(clientNameList)]);
                }
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getJobPostingsData()
    }, [jobDescForParticularClient, clientNameArr])

    // useEffect(() => {
    //     const getDashboardCountApi = async (id) => {
    //         try {
    //             const payload = {
    //                 email: id
    //             }
    //             const response = await DashboardCount(payload).unwrap()
    //             if (response) {
    //                 setDashboardCountDatas(response)
    //             } else {
    //                 setDashboardCountDatas({})
    //             }

    //         } catch (err) {
    //             Snackbar("Network Error", 'error')
    //         }
    //     }

    //     if (Profile) {
    //         getDashboardCountApi(Profile?.profile?.id)
    //     }
    // }, [Profile, DashboardCount])

    const getTableDatas = async () => {
        try {
            const payload = {
                // email: id,
                page: positionDesc === '' ? page - 1 : 0,
                size: rowsPerPage,
                clientId: clientNameArr || [],
                positionId: positionNameArr || [],
                eventId: eventTypeArr || [],
                sortingDirection: sortingDirection,
                sortingColumn: sortingColumn,
                positionDesc: positionDesc || ""
            }

            setShowTableLoader(true)
            const response = await GridDatas({ userRole, ...payload }).unwrap()
            setShowTableLoader(false)
            if (response) {
                setTableDatas(response[0]?.event || [])
                setTotalCount(response[0]?.noOfActivePost)
            }
        } catch (err) {
            Snackbar("Network failed", 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        getTableDatas()
    }, [])

    useEffect(() => {
        if (triggerApi) {
            getTableDatas()
            handleClose()
            setTriggerApi(false)
        }
    }, [GridDatas, clientNameArr, positionNameArr, eventTypeArr, page, rowsPerPage, sortingDirection, triggerApi, positionDesc])

    const handleSort = (columnName) => {
        if (sortingColumn === columnName) {
            setSortingDirection((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setTriggerApi(true)
        } else {
            setSortingColumn(columnName);
            setSortingDirection("ASC");
        }
    };

    const handleClientNameChange = (value) => {
        setClientName(value)
    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setPositionDesc(value)
        setPage(1)
        setTriggerApi(true)

        const currentFilter = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};

        const updatedFilter = {
            ...currentFilter,
            dashbord: {
                ...currentFilter.positionDesc,
                positionDesc: value
            }
        };
        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
    }

    const handleExcelDownload = async () => {
        try {
            setDownloadProgress(0); // start at 0%

            const payload = {
                // page: page - 1,
                // size: rowsPerPage,
                clientId: clientNameArr,
                positionId: positionNameArr,
                eventId: eventTypeArr,
                sortingDirection: sortingDirection,
                sortingColumn: sortingColumn,
            };

            const token = localStorage.getItem('token');
            setDashBoardDisabled(true)
            const response = await fetch(window.REACT_APP_BASE_URL + `v2/dashboardExcelFileDownload`, {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
            setDashBoardDisabled(false)

            if (!response.ok) throw new Error('Failed to Download');

            const contentLength = response.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : null;

            const reader = response.body.getReader();
            const chunks = [];
            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                chunks.push(value);
                receivedLength += value.length;

                if (total) {
                    const progress = Math.round((receivedLength / total) * 100);
                    setDownloadProgress(progress);
                } else {
                    // fallback: simulate small steps up to 95%
                    setDownloadProgress(prev => Math.min((prev || 0) + 3, 95));
                }
            }

            const blob = new Blob(chunks, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Dashboard Details.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            setDownloadProgress(100);

        } catch (err) {
            Snackbar('Network error', 'error');
        } finally {
            setTimeout(() => setDownloadProgress(null), 1000);
        }
    };



    const handleClientNameFilter = (e) => {
        const selectedClients = e.target.value;

        // Update the state
        setClientNameArr(selectedClients);

        // Update localStorage
        const currentLocalStorage = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};
        localStorage.setItem('commonsearchfilter', JSON.stringify({
            ...currentLocalStorage,
            dashbord: {
                ...currentLocalStorage.dashbord,
                clientId: selectedClients
            }
        }));

        // Your existing filter logic
        const filteredPositions = jobPostingArr?.filter((job) =>
            selectedClients?.includes?.(job?.clientId))?.map((id) => id?.positionId);
        setPositionNameArr((prev) => prev?.filter((id) => filteredPositions?.includes?.(id)));
    };

    const handleEventTypeFilter = (e) => {
        const value = e.target.value
        setEventTypeArr(value)

        const currentLocalStorage = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};
        localStorage.setItem('commonsearchfilter', JSON.stringify({
            ...currentLocalStorage,
            dashbord: {
                ...currentLocalStorage.dashbord,
                eventId: value
            }
        }));
    }

    const handlePositionNameFilter = (e) => {
        const value = e.target.value
        setPositionNameArr(value)

        const currentLocalStorage = JSON.parse(localStorage.getItem('commonsearchfilter')) || {};
        localStorage.setItem('commonsearchfilter', JSON.stringify({
            ...currentLocalStorage,
            dashbord: {
                ...currentLocalStorage.dashbord,
                positionId: value
            }
        }));
    }

    // const handlePositionFiltersChange = (positionId) => {
    //     setPositionNameFilterArr((prev) => (
    //         prev?.includes?.(positionId)
    //             ? prev?.filter((id) => id !== positionId)
    //             : [...prev, positionId]
    //     ))
    // }

    const clientNameFromArr = getClientDropdownlist?.response?.clientList?.filter((item) => (
        clientNameArr?.includes(item?.clientId)
    ))

    const eventType = eventsDropdown?.response?.filter((item) => (
        eventTypeArr?.includes?.(item?.eventTypeId)
    ))

    const jobPostingName = jobPostingArr?.filter((item) => (
        positionNameArr?.includes(item?.positionId)
    ))

    useEffect(() => {
        if (clientNameFromArr?.length === 0 && eventType?.length === 0 && jobPostingName?.length === 0) {
            setShowClearFilter(false)
        }
    }, [triggerApi])

    useEffect(() => {
        if (clientNameArr?.length > 0) {
            const positionName = jobPostingArr?.filter((item) => (
                clientNameArr?.includes(item?.clientId)
            ))
        } else {
            setPositionNameArr([])
        }
    }, [clientNameArr])

    const handleClientDelete = (name) => {
        setClientNameArr((prev) => (
            prev?.includes?.(name) && prev?.filter((data) => data !== name)
        ))

        const positionIdsToRemove = jobPostingArr?.filter((job) => job?.clientId === name)?.map(
            (job) => job?.positionId);
        setPositionNameArr((prev) => prev?.filter((id) => !positionIdsToRemove?.includes(id)));

        localStorage.setItem('commonsearchfilter', JSON.stringify({
            ...commonFilter,
            dashbord: {
                ...commonFilter.dashbord,
                clientId: positionNameArr
            }
        }));

        setTriggerApi(true)
    }

    const handleEventTypeDelete = (event) => {
        setEventTypeArr((prev) => (
            prev?.includes?.(event) && prev?.filter((data) => data !== event)
        ))

        const eventIds = commonFilter?.dashbord?.eventId || [];
        const updatedEventIds = eventIds.filter((id) => id !== event);

        const updatedFilter = {
            ...commonFilter,
            dashbord: {
                ...commonFilter.dashbord,
                eventId: updatedEventIds,
            },
        };

        localStorage.setItem('commonsearchfilter', JSON.stringify(updatedFilter));
        setTriggerApi(true)
    }

    const handlePositionDelete = (id) => {
        setPositionNameArr((prev) => (
            prev?.includes?.(id) && prev?.filter((item) => item !== id)
        ))
        setTriggerApi(true)
    }

    const handleClearFilter = () => {
        setEventTypeArr([])
        setPositionNameArr([])
        setClientNameArr([])
        setTriggerApi(true)
        setShowClearFilter(false)
        localStorage.setItem('commonsearchfilter', JSON.stringify({ ...commonFilter, dashbord: {} }))

    }

    const handleDashboardEventsNav = (item, eventTypeId, eventType) => {
        if (eventType !== 0) {
            navigate(`/dashboard-manage-events/${item?.JobId}/${eventTypeId}`, {
                state: { positionId: item?.JobId, eventTypeId: eventTypeId, clientName: item?.clientName, positionTitle: item?.positionName }
            })
        }
    }

    const handleSubmitProfileNav = (item) => {
        navigate(`/dashboard/submitprofiles/${item?.JobId}`,
            {
                state: {
                    positionName: item?.positionName, isDashboard: true
                }
            }
        )
    }

    const filteredTableDatas = tableDatas?.filter((name) => {
        return (
            (name?.positionName?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase())) ||
            (name?.clientName?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase())) ||
            (name?.JobId?.toString()?.startsWith(searchKeyword))
        )
    })

    useEffect(() => {
        const clientId = commonFilter?.dashbord?.clientId;
        const positionId = commonFilter?.dashbord?.positionId;
        const eventId = commonFilter?.dashbord?.eventId;

        const hasValue = clientId && clientId.length > 0;
        const hasPostion = positionId && positionId?.length > 0;
        const hasEvent = eventId && eventId?.length > 0;

        if (hasValue || hasPostion || hasEvent) {
            setShowClearFilter(true)
            setTriggerApi(true)
        }

    }, [])


    const tableColumnNames = [
        {
            label: 'Name'
        },
        {
            label: 'No of Positions'
        },
        {
            label: 'Profiles Identified'
        },
        {
            label: 'Scheduled (Internal)'
        },
        {
            label: 'Selected (Internal)'
        },
        {
            label: 'Submitted to Client'
        },
        {
            label: 'Scheduled (Client)'
        },
        {
            label: 'Selected (Client)'
        },
        {
            label: 'Pending Client Feedback'
        },
        {
            label: 'On Hold'
        },
        {
            label: 'Offered'
        },
        {
            label: 'Joined'
        },
        {
            label: 'Priority'
        },
        {
            label: 'Co-ordinator'
        },
    ]


    const [openNew, setOpenNew] = useState(false)
    const onOpenChange = (value) => {
        setOpenNew(value)
    }


    const darkTheme = createTheme({
        palette: {
            mode: "dark",
            primary: { main: "#3b82f6", light: "#60a5fa", dark: "#1d4ed8" },
            secondary: { main: "#06b6d4", light: "#22d3ee", dark: "#0891b2" },
            background: { default: "#0f172a", paper: "rgba(30, 41, 59, 0.8)" },
            text: { primary: "#f8fafc", secondary: "rgba(148, 163, 184, 0.8)" },
            success: { main: "#10b981" },
            error: { main: "#ef4444" },
            warning: { main: "#f59e0b" },
        },
        typography: {
            fontFamily: "system-ui, sans-serif",
            h4: { fontWeight: 700 },
            h6: { fontWeight: 500 },
        },
        components: {
            MuiDialog: { styleOverrides: { paper: { backgroundImage: "none" } } },
            MuiCard: { styleOverrides: { root: { backgroundImage: "none" } } },
        },
    })

    // ---------------- STYLED COMPONENTS ----------------
    const StyledDialog = styled(Dialog)(() => ({}))

    const StyledCard = styled(Card)(() => ({
        backgroundColor: "#fff",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(71, 85, 105, 0.3)",
        borderRadius: "12px",
        transition: "all 0.3s ease",
        animation: "fadeInUp 0.5s ease-out forwards",
        opacity: 0,
        transform: "translateY(20px)",
        // "&:hover": {
        //     backgroundColor: "rgba(30, 41, 59, 0.7)",
        //     transform: "translateY(-2px)",
        //     boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
        // },
        "@keyframes fadeInUp": { to: { opacity: 1, transform: "translateY(0)" } },
    }))

    // ---------------- HELPERS ----------------
    const AnimatedCounter = ({ value, duration = 2000 }) => {
        const [count, setCount] = useState(0)
        useEffect(() => {
            let startTime
            let animationFrame
            const animate = (ts) => {
                if (!startTime) startTime = ts
                const progress = Math.min((ts - startTime) / duration, 1)
                setCount(Math.floor(progress * value))
                if (progress < 1) animationFrame = requestAnimationFrame(animate)
            }
            animationFrame = requestAnimationFrame(animate)
            return () => cancelAnimationFrame(animationFrame)
        }, [value, duration])
        return <span>{count}</span>
    }

    const MiniChart = ({ data, color, trend }) => {
        const max = Math.max(...data)
        const min = Math.min(...data)
        const range = max - min || 1
        const points = data.map((v, i) => `${(i / (data.length - 1)) * 100},${100 - ((v - min) / range) * 100}`).join(" ")
        return (
            <Box sx={{ height: "64px", width: "100%", position: "relative" }}>
                <style>{`
        @keyframes drawLine { to { stroke-dashoffset: 0; } }
        @keyframes fadeIn { to { opacity: 1; } }
      `}</style>
                <svg style={{ width: "100%", height: "100%" }} viewBox="0 0 100 100" preserveAspectRatio="none">
                    <defs>
                        <linearGradient id={`gradient-${color.replace("#", "")}`} x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor={color} stopOpacity="0.3" />
                            <stop offset="100%" stopColor={color} stopOpacity="0.05" />
                        </linearGradient>
                    </defs>
                    <polyline
                        style={{
                            fill: "none", stroke: color, strokeWidth: 2,
                            filter: `drop-shadow(0 0 4px ${color}50)`,
                            strokeDasharray: "200", strokeDashoffset: "200",
                            animation: "drawLine 2s ease-out forwards",
                        }}
                        points={points}
                    />
                    <polygon
                        style={{ fill: `url(#gradient-${color.replace("#", "")})`, opacity: 0, animation: "fadeIn 1s ease-out 1s forwards" }}
                        points={`0,100 ${points} 100,100`}
                    />
                </svg>
            </Box>
        )
    }

    const StatCard = ({ metric, index }) => {
        const changePercent = ((metric.current - metric.previous) / metric.previous) * 100
        return (
            <StyledCard sx={{ animationDelay: `${index * 100}ms` }}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between">
                        <Stack direction="row" spacing={2}>
                            <Box sx={{ p: "12px", borderRadius: "8px", color: metric.color }}>
                                {metric.icon}
                            </Box>
                            <Box>
                                <Typography variant="h6" color="black">{metric.title}</Typography>
                                <Typography variant="body2" color="text.secondary">This Month</Typography>
                            </Box>
                        </Stack>
                        <Box textAlign="right">
                            <Typography variant="h4" color="black"><AnimatedCounter value={metric.current} /></Typography>
                            <Chip
                                size="small"
                                icon={changePercent >= 0 ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
                                label={`${Math.abs(changePercent).toFixed(1)}%`}
                                sx={{
                                    backgroundColor: changePercent >= 0 ? "rgba(16,185,129,0.2)" : "rgba(239,68,68,0.2)",
                                    color: changePercent >= 0 ? "#10b981" : "#ef4444",
                                    border: `1px solid ${changePercent >= 0 ? "rgba(16,185,129,0.4)" : "rgba(239,68,68,0.4)"}`,
                                    fontSize: "0.75rem", height: "24px", mt: "4px",
                                }}
                            />
                        </Box>
                    </Stack>
                    <MiniChart data={metric.chartData} color={metric.color} />
                    <Divider sx={{ my: 2, borderColor: "rgba(71, 85, 105, 0.3)" }} />
                    <Stack direction="row" justifyContent="space-between">
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                            <Typography variant="body2" color="text.secondary">Last Month :</Typography>
                            <Typography variant="body1" color="black">{metric.previous}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                            <Typography variant="body2" color="text.secondary">Total :</Typography>
                            <Typography variant="body1" color="black">{metric.total}</Typography>
                        </Box>
                    </Stack>
                </CardContent>
            </StyledCard>
        )
    }

    const generateMonthData = (value) => {
        const daysInMonth = new Date().getDate()
        const data = Array.from({ length: daysInMonth }, (_, i) => {
            if (i === daysInMonth - 1) return value
            return Math.floor(value * (i / (daysInMonth - 1)))
        })
        return data
    }

    const metrics = [
        { id: "jobs", title: "Jobs", current: dashCount?.positionCountCurrentMonth, previous: dashCount?.positionCountPreviousMonth, total: dashCount?.positionCount, icon: <Briefcase size={20} />, color: "#3b82f6", chartData: generateMonthData(dashCount?.positionCountCurrentMonth || 0) },
        { id: "clients", title: "Clients", current: dashCount?.clientCountCurrentMonth, previous: dashCount?.clientCountPreviousMonth, total: dashCount?.clientCount, icon: <Users size={20} />, color: "#06b6d4", chartData: generateMonthData(dashCount?.clientCountCurrentMonth || 0) },
        { id: "recruiters", title: "Internal Recruiters", current: dashCount?.internalRecruiterCountCurrentMonth, previous: dashCount?.internalRecruiterCountPreviousMonth, total: dashCount?.internalRecruiterCount, icon: <UserCheck size={20} />, color: "#10b981", chartData: generateMonthData(dashCount?.internalRecruiterCountCurrentMonth || 0) },
        { id: "BA", title: "Business Associate", current: dashCount?.businessAssociateCountCurrentMonth, previous: dashCount?.businessAssociateCountPreviousMonth, total: dashCount?.businessAssociateRecruiterCount, icon: <Briefcase size={20} />, color: "#f59e0b", chartData: generateMonthData(dashCount?.businessAssociateCountCurrentMonth || 0) },
        { id: "Candidates", title: "Candidates", current: dashCount?.profileCountCurrentMonth, previous: dashCount?.profileCountPreviousMonth, total: dashCount?.profileCount, icon: <UserCheck size={20} />, color: "#8b5cf6", chartData: generateMonthData(dashCount?.profileCountCurrentMonth || 0) },
    ]

    return (
        <Box className='container'>
            <div style={{ display: !isMediumScreen && 'flex', justifyContent: 'space-between' }}>
                <Typography className="title">Overview</Typography>

                <div style={{ display: 'flex', gap: '30px' }}>
                    <TextField
                        size="small"
                        className="textfields"
                        sx={{ width: '230px !important' }}
                        placeholder='Search By Position'
                        value={positionDesc}
                        slotProps={{
                            input: {
                                startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                            },
                        }}
                        onChange={handleSearchKeywordChange}
                    />
                    {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                        tableDatas?.length > 0 && (
                            <Tooltip
                                title={dashBoardDisabled === true && ('Please Wait...')}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: 'black',
                                            color: 'white',
                                            '& .MuiTooltip-arrow': {
                                                color: 'black',
                                            }
                                        }
                                    }
                                }}
                                arrow
                            >
                                <MUIButton
                                    title={downloadProgress !== null ? `Downloading... ${downloadProgress}%` : 'Download Report'}
                                    startIcon={<DownloadIcon stroke={'#fff'} />}
                                    sx={{ width: '200px' }}
                                    onClick={handleExcelDownload}
                                    disabled={dashBoardDisabled}
                                />
                            </Tooltip>
                        )
                    )}
                    <MUICancelButton
                        startIcon={<StatsIcon stroke={'#6941C6'} />}
                        title='View Stats'
                        sx={{ color: '#6941C6', width: '110px', borderColor: '#D6BBFB' }}
                        onClick={handleStatsOpen}
                    />
                </div>
            </div>

            <Grid2 item>
                <Dialog
                    open={statsOpen}
                    scroll="paper"
                    onClose={handleStatsClose}
                    sx={{
                        "& .MuiDialog-paper": {
                            position: 'fixed',
                            right: 0,
                            top: 0,
                            margin: 0,
                            bottom: 0,
                            maxHeight: '100vh',
                            width: '28vw',
                        }
                    }}
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 600 }}>
                        Statistics for this Month
                        <CloseIcon sx={{ color: '#52525B', cursor: 'pointer' }} onClick={handleStatsClose} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2.5}>
                                {/* Card 1 */}
                                <Grid2 item>
                                    <Card className="cardcontainer" elevation={3}
                                        sx={{
                                            backgroundColor: '#5ca8fe',
                                            color: "white !important",
                                            fontFamily: 'Roboto, sans-serif !important',
                                            borderRadius: '16px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: '-50px',
                                                right: '-50px',
                                                width: '150px',
                                                height: '150px',
                                                background: 'rgba(255, 255, 255, 0.08)',
                                                borderRadius: '50%',
                                            },
                                            '&:after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: '-60px',
                                                left: '-60px',
                                                width: '200px',
                                                height: '200px',
                                                background: 'rgba(255, 255, 255, 0.05)',
                                                borderRadius: '50%',
                                            }
                                        }}>
                                        <CardContent className="cardContentContainer">
                                            <Grid2
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    borderBottom: theme => '1px solid white'
                                                }}
                                            >
                                                <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: '5px' }}>
                                                    <Avatar
                                                        sx={{
                                                            background: dashCount?.positionPercentage > 0
                                                                ? 'rgb(224, 251, 232)'
                                                                : 'rgb(253, 228, 216)',
                                                            border: dashCount?.positionPercentage > 0
                                                                ? '1px solid rgba(5, 150, 105, 0.5)'
                                                                : '1px solid rgba(220, 38, 38, 0.5)',

                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                            backdropFilter: 'blur(6px)',
                                                            WebkitBackdropFilter: 'blur(6px)',
                                                            transition: 'all 0.3s ease',
                                                            margin: '0px 0px 5px 0px',
                                                            width: 45,
                                                            height: 45
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            // gap: '2px'
                                                        }}>
                                                            {dashCount?.positionPercentage > 0 ? (
                                                                <NorthEastRoundedIcon sx={{ fontSize: '14px', color: dashCount?.positionPercentage > 0 ? "green" : "red", }} />
                                                            ) : (
                                                                <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: dashCount?.positionPercentage > 0 ? "green" : "red" }} />
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '10px',
                                                                fontWeight: 600,
                                                                color: dashCount?.positionPercentage > 0 ? "green" : "red",
                                                                lineHeight: 1
                                                            }}>
                                                                {Math.round(Math.abs(dashCount?.positionPercentage || 0))}%
                                                            </Typography>
                                                        </Box>
                                                    </Avatar>

                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center' }}>
                                                        Jobs
                                                    </Typography>
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: '5px' }}>
                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                        {dashCount?.positionCount}
                                                    </Typography>
                                                    {/* <Box sx={{ width: '1px', height: '35px', backgroundColor: 'white', margin: '5px 0px' }} />
                                                    <Box className='percentBoxUnique' sx={{
                                                        background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                                        border: '1px solid rgba(255, 255, 255, 0.2)',
                                                        borderRadius: '10px',
                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '4px 10px',
                                                        backdropFilter: 'blur(6px)',
                                                        WebkitBackdropFilter: 'blur(6px)',
                                                        transition: 'all 0.3s ease',
                                                    }}>
                                                        {dashCount?.positionPercentage > 0 ?
                                                            <NorthEastRoundedIcon sx={{ fontSize: '14px', color: 'white' }} /> :
                                                            <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: 'white' }} />}
                                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#ffffff' }}>
                                                            {dashCount?.positionPercentage}%
                                                        </Typography>
                                                    </Box> */}

                                                </div>
                                            </Grid2>

                                            <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Box sx={{ padding: '15px' }}>
                                                    <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                        <b>Last Month Jobs <span><br />
                                                            {/* Count */}
                                                        </span></b>
                                                    </Typography>
                                                    <Typography sx={{ padding: '5px', fontSize: '13px', fontWeight: 'bold' }}>
                                                        {dashCount?.positionCountPreviousMonth}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: '1px', height: '50px', backgroundColor: 'white', marginTop: '10px' }} />
                                                <Box sx={{ padding: '15px' }}>
                                                    <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                        <b>Current Month Jobs <span><br />
                                                            {/* Count */}
                                                        </span></b>
                                                    </Typography>
                                                    <Typography sx={{ padding: '5px', fontSize: '13px', fontWeight: 'bold' }}>
                                                        {dashCount?.positionCountCurrentMonth}
                                                    </Typography>
                                                </Box>
                                            </Grid2>
                                        </CardContent>
                                    </Card>
                                </Grid2>

                                {/* Card 2 */}
                                {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                                    <>
                                        <Grid2 item>
                                            <Card className="cardcontainer" elevation={3}
                                                sx={{
                                                    backgroundColor: '#5ca8fe',
                                                    color: 'white',
                                                    fontFamily: 'Roboto, sans-serif !important',
                                                    borderRadius: '16px',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                                                    '&:before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: '-50px',
                                                        right: '-50px',
                                                        width: '150px',
                                                        height: '150px',
                                                        background: 'rgba(255, 255, 255, 0.08)',
                                                        borderRadius: '50%',
                                                    },
                                                    '&:after': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        bottom: '-60px',
                                                        left: '-60px',
                                                        width: '200px',
                                                        height: '200px',
                                                        background: 'rgba(255, 255, 255, 0.05)',
                                                        borderRadius: '50%',
                                                    }
                                                }}>
                                                <CardContent className="cardContentContainer">
                                                    <Grid2
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            borderBottom: theme => '1px solid white'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: '5px' }}>
                                                            <Avatar
                                                                sx={{
                                                                    background: dashCount?.clientPercentage > 0
                                                                        ? 'rgb(224, 251, 232)'
                                                                        : 'rgb(253, 228, 216)',
                                                                    border: dashCount?.clientPercentage > 0
                                                                        ? '1px solid rgba(5, 150, 105, 0.5)'
                                                                        : '1px solid rgba(220, 38, 38, 0.5)',

                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                    backdropFilter: 'blur(6px)',
                                                                    WebkitBackdropFilter: 'blur(6px)',
                                                                    transition: 'all 0.3s ease',
                                                                    margin: '0px 0px 5px 0px',
                                                                    width: 45,
                                                                    height: 45
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    // gap: '2px'
                                                                }}>
                                                                    {dashCount?.clientPercentage > 0 ? (
                                                                        <NorthEastRoundedIcon sx={{ fontSize: '14px', color: dashCount?.clientPercentage > 0 ? "green" : "red", }} />
                                                                    ) : (
                                                                        <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: dashCount?.clientPercentage > 0 ? "green" : "red" }} />
                                                                    )}
                                                                    <Typography sx={{
                                                                        fontSize: '10px',
                                                                        fontWeight: 600,
                                                                        color: dashCount?.clientPercentage > 0 ? "green" : "red",
                                                                        lineHeight: 1
                                                                    }}>
                                                                        {Math.round(Math.abs(dashCount?.clientPercentage || 0))}%
                                                                    </Typography>
                                                                </Box>
                                                            </Avatar>
                                                            {/* {dashCount?.clientPercentage > 0 ? (
                                                                <TrendingUpRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#DCFAE6', color: '#079455', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            ) : (
                                                                <TrendingDownRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#FEE4E2', color: '#D92D20', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            )} */}
                                                            <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Clients
                                                            </Typography>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                                {dashCount?.clientCount}
                                                            </Typography>
                                                            {/* <Box sx={{ width: '1px', height: '35px', backgroundColor: 'white', margin: '5px 0px' }} /> */}
                                                            {/* <Box className='percentBoxUnique' sx={{
                                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                                borderRadius: '10px',
                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                padding: '4px 10px',
                                                                backdropFilter: 'blur(6px)',
                                                                WebkitBackdropFilter: 'blur(6px)',
                                                                transition: 'all 0.3s ease',
                                                            }}>
                                                                {dashCount?.clientPercentage > 0 ?
                                                                    <NorthEastRoundedIcon sx={{ fontSize: '14px', color: 'white' }} /> :
                                                                    <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: 'white' }} />}
                                                                <Typography sx={{ fontSize: '11px', fontWeight: 'bold' }}>
                                                                    {dashCount?.clientPercentage}%
                                                                </Typography>
                                                            </Box> */}
                                                        </div>
                                                    </Grid2>
                                                    <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Last Month Clients
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                                {dashCount?.clientCountPreviousMonth}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: '1px', height: '50px', backgroundColor: 'white', marginTop: '10px' }} />
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Current Month Clients
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ padding: '5px', fontSize: '13px', fontWeight: 'bold' }}>
                                                                {dashCount?.clientCountCurrentMonth}
                                                            </Typography>
                                                        </Box>
                                                    </Grid2>
                                                </CardContent>
                                            </Card>
                                        </Grid2>
                                        {/* card 3 */}
                                        <Grid2 item>
                                            <Card className="cardcontainer" elevation={3}
                                                sx={{
                                                    backgroundColor: '#5ca8fe',
                                                    color: 'white',
                                                    fontFamily: 'Roboto, sans-serif !important',
                                                    borderRadius: '16px',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                                                    '&:before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: '-50px',
                                                        right: '-50px',
                                                        width: '150px',
                                                        height: '150px',
                                                        background: 'rgba(255, 255, 255, 0.08)',
                                                        borderRadius: '50%',
                                                    },
                                                    '&:after': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        bottom: '-60px',
                                                        left: '-60px',
                                                        width: '200px',
                                                        height: '200px',
                                                        background: 'rgba(255, 255, 255, 0.05)',
                                                        borderRadius: '50%',
                                                    }
                                                }}>
                                                <CardContent className="cardContentContainer">
                                                    <Grid2
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            borderBottom: theme => '1px solid white'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: '5px' }}>
                                                            <Avatar
                                                                sx={{
                                                                    background: dashCount?.internalRecruiterPercentage > 0
                                                                        ? 'rgb(224, 251, 232)'
                                                                        : 'rgb(253, 228, 216)',
                                                                    border: dashCount?.internalRecruiterPercentage > 0
                                                                        ? '1px solid rgba(5, 150, 105, 0.5)'
                                                                        : '1px solid rgba(220, 38, 38, 0.5)',

                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                    backdropFilter: 'blur(6px)',
                                                                    WebkitBackdropFilter: 'blur(6px)',
                                                                    transition: 'all 0.3s ease',
                                                                    margin: '0px 0px 5px 0px',
                                                                    width: 45,
                                                                    height: 45
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    // gap: '2px'
                                                                }}>
                                                                    {dashCount?.internalRecruiterPercentage > 0 ? (
                                                                        <NorthEastRoundedIcon sx={{ fontSize: '14px', color: dashCount?.internalRecruiterPercentage > 0 ? "green" : "red", }} />
                                                                    ) : (
                                                                        <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: dashCount?.internalRecruiterPercentage > 0 ? "green" : "red" }} />
                                                                    )}
                                                                    <Typography sx={{
                                                                        fontSize: '10px',
                                                                        fontWeight: 600,
                                                                        color: dashCount?.internalRecruiterPercentage > 0 ? "green" : "red",
                                                                        lineHeight: 1
                                                                    }}>
                                                                        {Math.round(Math.abs(dashCount?.internalRecruiterPercentage || 0))}%
                                                                    </Typography>
                                                                </Box>
                                                            </Avatar>
                                                            {/* {dashCount?.internalRecruiterPercentage > 0 ? (
                                                                <TrendingUpRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#DCFAE6', color: '#079455', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            ) : (
                                                                <TrendingDownRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#FEE4E2', color: '#D92D20', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            )} */}
                                                            <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Internal Recruiters
                                                            </Typography>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                                {dashCount?.internalRecruiterCount}
                                                            </Typography>
                                                            {/* <Box sx={{ width: '1px', height: '35px', backgroundColor: 'white', margin: '5px 0px' }} />
                                                            <Box className='percentBoxUnique' sx={{
                                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                                borderRadius: '10px',
                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                padding: '4px 10px',
                                                                backdropFilter: 'blur(6px)',
                                                                WebkitBackdropFilter: 'blur(6px)',
                                                                transition: 'all 0.3s ease',
                                                            }}>{dashCount?.internalRecruiterPercentage > 0 ?
                                                                <NorthEastRoundedIcon sx={{ fontSize: '14px', color: 'white' }} /> :
                                                                <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: 'white' }} />}
                                                                <Typography sx={{ fontSize: '11px', fontWeight: 'bold' }}>
                                                                    {dashCount?.internalRecruiterPercentage}%
                                                                </Typography>
                                                            </Box> */}
                                                        </div>
                                                    </Grid2>
                                                    <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Last Month Recruiters
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                                {dashCount?.internalRecruiterCountPreviousMonth}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: '1px', height: '50px', backgroundColor: 'white', marginTop: '10px' }} />
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Current Month Recruiters
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                                {dashCount?.internalRecruiterCountCurrentMonth}
                                                            </Typography>
                                                        </Box>
                                                    </Grid2>
                                                </CardContent>
                                            </Card>

                                        </Grid2>
                                        {/* card 4 */}
                                        <Grid2 item>
                                            <Card className="cardcontainer" elevation={3}
                                                sx={{
                                                    backgroundColor: '#5ca8fe',
                                                    color: 'white',
                                                    fontFamily: 'Roboto, sans-serif !important',
                                                    borderRadius: '16px',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                                                    '&:before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: '-50px',
                                                        right: '-50px',
                                                        width: '150px',
                                                        height: '150px',
                                                        background: 'rgba(255, 255, 255, 0.08)',
                                                        borderRadius: '50%',
                                                    },
                                                    '&:after': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        bottom: '-60px',
                                                        left: '-60px',
                                                        width: '200px',
                                                        height: '200px',
                                                        background: 'rgba(255, 255, 255, 0.05)',
                                                        borderRadius: '50%',
                                                    }
                                                }}>
                                                <CardContent className="cardContentContainer">
                                                    <Grid2
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            borderBottom: theme => '1px solid white'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: '5px' }}>
                                                            <Avatar
                                                                sx={{
                                                                    background: dashCount?.businessAssociatePercentage > 0
                                                                        ? 'rgb(224, 251, 232)'
                                                                        : 'rgb(253, 228, 216)',
                                                                    border: dashCount?.businessAssociatePercentage > 0
                                                                        ? '1px solid rgba(5, 150, 105, 0.5)'
                                                                        : '1px solid rgba(220, 38, 38, 0.5)',

                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                    backdropFilter: 'blur(6px)',
                                                                    WebkitBackdropFilter: 'blur(6px)',
                                                                    transition: 'all 0.3s ease',
                                                                    margin: '0px 0px 5px 0px',
                                                                    width: 45,
                                                                    height: 45
                                                                }}
                                                            >
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    // gap: '2px'
                                                                }}>
                                                                    {dashCount?.businessAssociatePercentage > 0 ? (
                                                                        <NorthEastRoundedIcon sx={{ fontSize: '14px', color: dashCount?.businessAssociatePercentage > 0 ? "green" : "red", }} />
                                                                    ) : (
                                                                        <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: dashCount?.businessAssociatePercentage > 0 ? "green" : "red" }} />
                                                                    )}
                                                                    <Typography sx={{
                                                                        fontSize: '10px',
                                                                        fontWeight: 600,
                                                                        color: dashCount?.businessAssociatePercentage > 0 ? "green" : "red",
                                                                        lineHeight: 1
                                                                    }}>
                                                                        {Math.round(Math.abs(dashCount?.businessAssociatePercentage || 0))}%
                                                                    </Typography>
                                                                </Box>
                                                            </Avatar>
                                                            {/* {dashCount?.businessAssociatePercentage > 0 ? (
                                                                <TrendingUpRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#DCFAE6', color: '#079455', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            ) : (
                                                                <TrendingDownRoundedIcon
                                                                    className="cardIcon"
                                                                    sx={{ backgroundColor: '#FEE4E2', color: '#D92D20', borderRadius: '50%', padding: '4px' }}
                                                                />
                                                            )} */}
                                                            <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                Business Associates
                                                            </Typography>
                                                        </div>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                                {dashCount?.businessAssociateRecruiterCount}
                                                            </Typography>
                                                            {/* <Box sx={{ width: '1px', height: '35px', backgroundColor: 'white', margin: '5px 0px' }} />
                                                            <Box className='percentBoxUnique' sx={{
                                                                background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                                                borderRadius: '10px',
                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '6px',
                                                                padding: '4px 10px',
                                                                backdropFilter: 'blur(6px)',
                                                                WebkitBackdropFilter: 'blur(6px)',
                                                                transition: 'all 0.3s ease',
                                                            }}>
                                                                {dashCount?.businessAssociatePercentage > 0 ?
                                                                    <NorthEastRoundedIcon sx={{ fontSize: '14px', color: 'white' }} /> :
                                                                    <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: 'white' }} />}
                                                                <Typography sx={{ fontSize: '11px', fontWeight: 'bold' }}>
                                                                    {dashCount?.businessAssociatePercentage}%
                                                                </Typography>
                                                            </Box> */}
                                                        </div>
                                                    </Grid2>
                                                    <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Last Month BAs
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                                {dashCount?.businessAssociateCountPreviousMonth}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: '1px', height: '50px', backgroundColor: 'white', marginTop: '10px' }} />
                                                        <Box sx={{ padding: '15px' }}>
                                                            <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                                <b>Current Month BAs
                                                                    {/* Count */}
                                                                </b>
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                                {dashCount?.businessAssociateCountCurrentMonth}
                                                            </Typography>
                                                        </Box>
                                                    </Grid2>
                                                </CardContent>
                                            </Card>
                                        </Grid2>
                                    </>
                                )}

                                {/* card 5 */}
                                <Grid2 item>
                                    <Card className="cardcontainer" elevation={3}
                                        sx={{
                                            backgroundColor: '#5ca8fe',
                                            color: 'white',
                                            fontFamily: 'Roboto, sans-serif !important',
                                            borderRadius: '16px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                                            '&:before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: '-40px',
                                                right: '-40px',
                                                width: '150px',
                                                height: '150px',
                                                background: 'rgba(255, 255, 255, 0.08)',
                                                borderRadius: '50%',
                                            },
                                            '&:after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: '-40px',
                                                left: '-40px',
                                                width: '120px',
                                                height: '120px',
                                                background: 'rgba(255, 255, 255, 0.05)',
                                                borderRadius: '50%',
                                            }
                                        }}>
                                        <CardContent className="cardContentContainer">
                                            <Grid2
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    borderBottom: '1px solid white'
                                                }}
                                            >
                                                <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: '5px' }}>
                                                    <Avatar
                                                        sx={{
                                                            background: dashCount?.profilePercentage > 0
                                                                ? 'rgb(224, 251, 232)'
                                                                : 'rgb(253, 228, 216)',
                                                            border: dashCount?.profilePercentage > 0
                                                                ? '1px solid rgba(5, 150, 105, 0.5)'
                                                                : '1px solid rgba(220, 38, 38, 0.5)',

                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                            backdropFilter: 'blur(6px)',
                                                            WebkitBackdropFilter: 'blur(6px)',
                                                            transition: 'all 0.3s ease',
                                                            margin: '0px 0px 5px 0px',
                                                            width: 45,
                                                            height: 45
                                                        }}
                                                    >
                                                        <Box sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            // gap: '2px'
                                                        }}>
                                                            {dashCount?.profilePercentage > 0 ? (
                                                                <NorthEastRoundedIcon sx={{ fontSize: '14px', color: dashCount?.profilePercentage > 0 ? "green" : "red", }} />
                                                            ) : (
                                                                <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: dashCount?.profilePercentage > 0 ? "green" : "red" }} />
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '10px',
                                                                fontWeight: 600,
                                                                color: dashCount?.profilePercentage > 0 ? "green" : "red",
                                                                lineHeight: 1
                                                            }}>
                                                                {Math.round(Math.abs(dashCount?.profilePercentage || 0))}%
                                                            </Typography>
                                                        </Box>
                                                    </Avatar>
                                                    {/* {dashCount?.profilePercentage > 0 ? (
                                                        <TrendingUpRoundedIcon
                                                            className="cardIcon"
                                                            sx={{ backgroundColor: '#DCFAE6', color: '#079455', borderRadius: '50%', padding: '4px' }}
                                                        />
                                                    ) : (
                                                        <TrendingDownRoundedIcon
                                                            className="cardIcon"
                                                            sx={{ backgroundColor: '#FEE4E2', color: '#D92D20', borderRadius: '50%', padding: '4px' }}
                                                        />
                                                    )} */}
                                                    <Typography variant="body1" sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                        Candidates
                                                    </Typography>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                        {dashCount?.profileCount}
                                                    </Typography>
                                                    {/* <Box sx={{ width: '1px', height: '35px', backgroundColor: 'white', margin: '5px 0px' }} />
                                                    <Box className='percentBoxUnique' sx={{
                                                        background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                                                        border: '1px solid rgba(255, 255, 255, 0.2)',
                                                        borderRadius: '10px',
                                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        padding: '4px 10px',
                                                        backdropFilter: 'blur(6px)',
                                                        WebkitBackdropFilter: 'blur(6px)',
                                                        transition: 'all 0.3s ease',
                                                    }}>
                                                        {dashCount?.profilePercentage > 0 ?
                                                            <NorthEastRoundedIcon sx={{ fontSize: '14px', color: 'white' }} /> :
                                                            <CallReceivedRoundedIcon sx={{ fontSize: '14px', color: 'white' }} />}
                                                        <Typography sx={{
                                                            fontSize: '11px',
                                                            fontWeight: 'bold',
                                                            letterSpacing: '0.2px'
                                                        }}>
                                                            {dashCount?.profilePercentage}%
                                                        </Typography>
                                                    </Box> */}
                                                </div>
                                            </Grid2>
                                            <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Box sx={{ padding: '15px' }}>
                                                    <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                        <b>Last Month Candidates
                                                            {/* Count */}
                                                        </b>
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                        {dashCount?.profileCountPreviousMonth}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: '1px', height: '50px', backgroundColor: 'white', marginTop: '10px' }} />
                                                <Box sx={{ padding: '15px' }}>
                                                    <Typography sx={{ display: 'flex', fontSize: '10px', fontWeight: 'bold' }}>
                                                        <b>Current Month Candidates
                                                            {/* Count */}
                                                        </b>
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '13px', padding: '5px', fontWeight: 'bold' }}>
                                                        {dashCount?.profileCountCurrentMonth}
                                                    </Typography>
                                                </Box>
                                            </Grid2>
                                        </CardContent>
                                    </Card>
                                </Grid2>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>

                </Dialog>
            </Grid2>

            <Grid2 container sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
            }}>

                {/* Alert */}
                <Grid2 item sx={{ width: "100%" }}>
                    {/* <Box sx={{ border: '1px solid #D5D7DA', padding: '16px', marginTop: '30px', borderRadius: '12px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>

                                    <div style={{ border: '2px solid #fbe9d9', borderRadius: '80px', height: '30px', width: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div style={{ border: '2px solid #ffc795', borderRadius: '80px', height: '23px', width: '23px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <ErrorOutlineIcon sx={{ color: '#DC6803', fontSize: '18.5px' }} />
                                        </div>
                                    </div>

                                    <div>
                                        <Typography sx={{ color: '#414651', fontSize: '13px', fontWeight: 600 }}>5 Candidates waiting for review for 48 hours.</Typography>
                                        <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '13px' }}>5 candidates application has been waiting for review for 48 hours. Let’s take action to keep the process moving.</Typography>
                                        <Grid2 item sx={{ display: 'flex', marginTop: '10px', gap: '12px' }}>
                                            <Typography sx={{ fontSize: '12.5px', color: '#535862', fontWeight: 600 }}>Review Application</Typography>
                                            <Typography sx={{ color: '#6941C6', fontWeight: 600, fontSize: '12.5px', cursor: 'pointer' }}>Assign to Hiring Manager</Typography>
                                        </Grid2>
                                    </div>
                                </div>
                            </div>
                            <CloseIcon sx={{ color: '#A4A7AE', fontSize: '18px', cursor: 'pointer' }} />
                        </Box>
                    </Box> */}
                    {/* {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                        <Grid2 item sx={{ width: "30%" }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                <Box sx={{ flex: 1 }}>
                                    <Dropdown
                                        placeholder='Select Client'
                                        options={getClientDropdownlist?.response?.clientList || []}
                                        valueKey="clientName"
                                        labelKey="clientName"
                                        value={clientName || ""}
                                        onChange={(value) => handleClientNameChange(value)}
                                    />
                                </Box>
                            </Box>
                        </Grid2>
                    )} */}
                </Grid2>

                <Grid2 item>
                    <Dialog
                        open={open}
                        scroll="paper"
                        maxWidth="md"
                        className="sidePopup"
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 600 }}>
                            Filters
                            <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid2 item container gap={3}>
                                <Grid2 item sx={{ width: '100%' }}>
                                    <InputLabel className="inputlabels">Client Names</InputLabel>
                                    <Select
                                        value={clientNameArr}
                                        onChange={handleClientNameFilter}
                                        open={openClientName}
                                        onOpen={() => setOpenClientName(true)}
                                        onClose={() => setOpenClientName(false)}
                                        displayEmpty
                                        sx={{ width: '100%', height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                        renderValue={(selected) => {
                                            return (
                                                selected?.length < 1
                                                    ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}> Choose one or more </p>
                                                    : clientNameFromArr?.map((client) => client?.clientName)?.join(', ')
                                            )
                                        }}
                                        multiple
                                        MenuProps={{
                                            style: {
                                                maxHeight: 490
                                            }
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1 }}>
                                            <MenuItem value='' className="menuItemsPlaceholder" disabled>Select Client Name</MenuItem>
                                            <Tooltip title="Close" arrow>
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOpenClientName(false);
                                                    }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                >
                                                    <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {getClientDropdownlist?.response?.clientList?.map((item) => (
                                            <MenuItem key={item?.clientId} value={item?.clientId} className="menuitems">
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <Checkbox
                                                        sx={{
                                                            '& .MuiSvgIcon-root': { fontSize: 18 },
                                                            '&.Mui-checked': {
                                                                color: '#7F56D9',
                                                            },
                                                            padding: 0
                                                        }}
                                                        checked={clientNameArr?.includes(item?.clientId)}
                                                    />
                                                    {item?.clientName}
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>

                                <Grid2 item sx={{ width: '100%' }}>
                                    <InputLabel className="inputlabels">Position Names</InputLabel>
                                    <Select
                                        value={positionNameArr}
                                        onChange={handlePositionNameFilter}
                                        displayEmpty
                                        open={openPositionTypes}
                                        onOpen={() => setOpenPositionTypes(true)}
                                        onClose={() => setOpenPositionTypes(false)}
                                        sx={{ width: '100%', height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                        multiple
                                        renderValue={(selected) => {
                                            return (
                                                selected?.length < 1
                                                    ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Choose one or more</p>
                                                    : jobPostingName?.map((item) => item?.positionDesc)?.join(', ')
                                            )
                                        }}
                                        MenuProps={{
                                            style: {
                                                maxHeight: 400
                                            }
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MenuItem value='' disabled className="menuItemsPlaceholder">Select Position Name</MenuItem>
                                            <Tooltip
                                                title={"Close"}
                                                arrow
                                            >
                                                <IconButton size="small" onClick={(e) => {
                                                    e.stopPropagation();
                                                    setOpenPositionTypes(false);
                                                }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                >
                                                    <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {jobPostingArr?.map((item) => (
                                            <MenuItem key={item?.positionId} value={item?.positionId} className="menuitems">
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <Checkbox
                                                        sx={{
                                                            "& .MuiSvgIcon-root": {
                                                                fontSize: 18
                                                            },
                                                            "&.Mui-checked": {
                                                                color: '#7F56D9'
                                                            },
                                                            marginTop: '-13px',
                                                            padding: 0
                                                        }}
                                                        checked={positionNameArr?.includes(item?.positionId)}
                                                    />
                                                    <div>
                                                        {item?.positionDesc}
                                                        <Typography sx={{ fontSize: '10px', color: '#52525B', fontWeight: 600 }}>{item?.clientName}</Typography>
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {clientNameArr?.length === 0 && (
                                        <Typography sx={{ color: '#535862', fontSize: '12px' }}>Select client name to get position name for that particular client</Typography>
                                    )}
                                </Grid2>

                                <Grid2 item sx={{ width: '100%' }}>
                                    <InputLabel className="inputlabels">Event Types</InputLabel>
                                    <Select
                                        value={eventTypeArr}
                                        onChange={handleEventTypeFilter}
                                        displayEmpty
                                        open={openEventName}
                                        onOpen={() => setOpenEventName(true)}
                                        onClose={() => setOpenEventName(false)}
                                        multiple
                                        sx={{ width: '100%', height: '35px', fontSize: '14px', borderRadius: '10px' }}
                                        renderValue={(selected) => {
                                            return (
                                                selected?.length < 1
                                                    ? <p style={{ color: '#a2a2a2', fontSize: '14px' }}>Choose one or more</p>
                                                    : eventType?.map((item) => item?.event)?.join(', ')
                                            )
                                        }}
                                        MenuProps={{
                                            style: {
                                                maxHeight: 350
                                            }
                                        }}
                                        IconComponent={KeyboardArrowDownIcon}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MenuItem value='' disabled className="menuItemsPlaceholder">Select Event Name</MenuItem>
                                            <Tooltip
                                                title={"Close"}
                                                arrow
                                            >
                                                <IconButton size="small" onClick={(e) => {
                                                    e.stopPropagation();
                                                    setOpenEventName(false);
                                                }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                >
                                                    <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {eventsDropdown?.response?.map((item) => (
                                            <MenuItem key={item?.eventTypeId} value={item?.eventTypeId} className="menuitems">
                                                <div style={{ display: 'flex', gap: '5px' }}>
                                                    <Checkbox
                                                        checked={eventTypeArr?.includes(item?.eventTypeId)}
                                                        sx={{
                                                            "& .MuiSvgIcon-root": { fontSize: 18 },
                                                            "&.Mui-checked": {
                                                                color: '#7F56D9'
                                                            },
                                                            padding: 0
                                                        }}
                                                    />
                                                    {item?.event}
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>
                            </Grid2>

                        </DialogContent>
                        <DialogActions>
                            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <MUICancelButton title='Cancel' sx={{ width: '41%' }} onClick={handleClose} />
                                <MUIButton title='Apply' sx={{ width: '42%' }}
                                    onClick={() => {
                                        setPage(1);
                                        setShowClearFilter(true)
                                        setTriggerApi(true)
                                    }}
                                />
                            </Grid2>
                        </DialogActions>
                    </Dialog>
                </Grid2>

                {/* Table container */}
                <Grid2 container sx={{ width: '100%' }}>
                    <Paper sx={{ width: '100%', overflow: 'auto', marginTop: "25px", border: '1px solid #E9EAEB' }} elevation={0}>
                        <Table>
                            <TableHead>
                                {(Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') && (
                                    <TableRow>
                                        <TableCell colSpan={100} sx={{ padding: '5px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {showClearFilter ? (
                                                    <div>
                                                        {clientNameArr?.map((item, index) => {
                                                            const clientName = clientNameFromArr?.find((client) => client?.clientId === item)
                                                            return (
                                                                <Chip className="Chip" key={index} label={clientName?.clientName} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={() => handleClientDelete(item)} />
                                                            )
                                                        })}
                                                        {positionNameArr?.map((item, index) => {
                                                            const postingName = jobPostingName?.find((job) => job?.positionId === item)
                                                            return (
                                                                <Chip className="Chip" key={index} label={postingName?.positionDesc} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={() => handlePositionDelete(item)} />
                                                            )
                                                        })}
                                                        {eventTypeArr?.map((item, index) => {
                                                            const eventTypeName = eventType?.find((id) => id?.eventTypeId === item)
                                                            return (
                                                                <Chip className="Chip" key={index} label={eventTypeName?.event} variant="outlined" size='small' deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />} onDelete={() => handleEventTypeDelete(item)} />
                                                            )
                                                        })}
                                                    </div>
                                                ) : <div />}
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
                                                    <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', fontWeight: 600, width: '130px', borderColor: '#D6BBFB' }} />
                                                    {(eventTypeArr?.length > 0 || positionNameArr?.length > 0 || clientNameArr?.length > 0) && showClearFilter && (
                                                        <MUICancelButton title='Clear Filter' onClick={handleClearFilter} sx={{ width: '100px' }} />
                                                    )}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableRow>
                                    {tableColumnNames?.map((column, index) => (
                                        <Tooltip
                                            slotProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: "#0A0D12",
                                                        borderRadius: '8px',
                                                        padding: '8px 12px',
                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                    }
                                                }
                                            }}
                                            title={column?.label?.length > 20 && column?.label} arrow placement='top'>
                                            <TableCell
                                                key={index}
                                                className="dashboardTableHeaders"
                                            >
                                                {column?.label === 'Name' ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                        onClick={() => handleSort("positionDesc")}
                                                    >
                                                        {column?.label}
                                                        <UnfoldMoreIcon sx={{ fontSize: '17px' }} />
                                                    </div>
                                                ) : (
                                                    column?.label?.length > 20 ? column?.label?.substring(0, 14) + '...' : column?.label
                                                )}
                                            </TableCell>
                                        </Tooltip>
                                    ))}
                                </TableRow>
                            </TableHead>

                            {!showTableLoader ? (
                                filteredTableDatas?.length > 0 ? (
                                    <TableBody>
                                        {filteredTableDatas?.map((item, index) => {
                                            const coordinators = item?.coordinatorData?.split(',')?.map((name) => name?.trim())
                                            const twoCoordinators = coordinators?.slice(0, 2)?.join(', ')
                                            const remainingCoordinators = coordinators?.slice(2)
                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: index % 2 === 1 ? '#FAFAFA' : 'inherit',
                                                        '&:hover': { backgroundColor: '#f1f1f1' },
                                                    }}>
                                                    <TableCell className="dashboardTableBody" sx={{ width: '15%' }}>
                                                        <Tooltip
                                                            slotProps={{
                                                                tooltip: {
                                                                    sx: {
                                                                        backgroundColor: "#0A0D12",
                                                                        borderRadius: '8px',
                                                                        padding: '8px 12px',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }
                                                                }
                                                            }}
                                                            title={item?.positionName?.length > 20 && item?.positionName} arrow placement="top">
                                                            <b style={{ color: '#53389E', cursor: 'pointer', fontWeight: 550, fontFamily: "Inter, sans-serif" }}
                                                                onClick={() => handleSubmitProfileNav(item)}
                                                            >
                                                                {item?.positionName?.length > 20 ? item?.positionName?.substring(0, 19) + '...' : item?.positionName}
                                                            </b>
                                                        </Tooltip> <br />
                                                        <span style={{ display: 'flex', gap: '5px' }}>
                                                            {item?.JobId}
                                                            <Tooltip
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                                title={item?.clientName?.length > 20 && item?.clientName} arrow>
                                                                {item?.clientName?.length > 20 ? item?.clientName?.substring(0, 19) + '...' : item?.clientName}
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left" sx={{ color: '#52525B' }}>{item?.noOfPosition}</TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.profileIdentified?.eventType, item?.profileIdentified?.count)}
                                                        sx={{
                                                            color: item?.profileIdentified?.count !== 0 ? '#6941C6' : '#000',
                                                            cursor: item?.profileIdentified?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.profileIdentified?.count ? item?.profileIdentified?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.scheduldeInternal?.eventType, item?.scheduldeInternal?.count)}
                                                        sx={{
                                                            color: item?.scheduldeInternal?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.scheduldeInternal?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.scheduldeInternal?.count ? item?.scheduldeInternal?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.selectedInternal?.eventType, item?.selectedInternal?.count)}
                                                        sx={{
                                                            color: item?.selectedInternal?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.selectedInternal?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.selectedInternal?.count ? item?.selectedInternal?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.submittedToClient?.eventType, item?.submittedToClient?.count)}
                                                        sx={{
                                                            color: item?.submittedToClient?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.submittedToClient?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.submittedToClient?.count ? item?.submittedToClient?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.scheduldeClient?.eventType, item?.scheduldeClient?.count)}
                                                        sx={{
                                                            color: item?.scheduldeClient?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.scheduldeClient?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.scheduldeClient?.count ? item?.scheduldeClient?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.selectedClient?.eventType, item?.selectedClient?.count)}
                                                        sx={{
                                                            color: item?.selectedClient?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.selectedClient?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.selectedClient?.count ? item?.selectedClient?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.pendingClientFeedback?.eventType, item?.pendingClientFeedback?.count)}
                                                        sx={{
                                                            color: item?.pendingClientFeedback?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.pendingClientFeedback?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.pendingClientFeedback?.count ? item?.pendingClientFeedback?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.onHold?.eventType, item?.onHold?.count)}
                                                        sx={{
                                                            color: item?.onHold?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.onHold?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.onHold?.count ? item?.onHold?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.offered?.eventType, item?.offered?.count)}
                                                        sx={{
                                                            color: item?.offered?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.offered?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.offered?.count ? item?.offered?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody" align="left"
                                                        onClick={() => handleDashboardEventsNav(item, item?.joined?.eventType, item?.joined?.count)}
                                                        sx={{
                                                            color: item?.joined?.count !== 0 ? '#53389E' : '#000',
                                                            cursor: item?.joined?.count !== 0 ? 'pointer' : 'auto'
                                                        }}
                                                    >
                                                        {item?.joined?.count ? item?.joined?.count : ""}
                                                    </TableCell>
                                                    <TableCell className="dashboardTableBody">
                                                        <Box className={`priority-badge ${item?.priority?.toLowerCase()}`}>
                                                            {item?.priority}
                                                        </Box>
                                                    </TableCell>
                                                    <Tooltip
                                                        slotProps={{
                                                            tooltip: {
                                                                sx: {
                                                                    backgroundColor: "#0A0D12",
                                                                    borderRadius: '8px',
                                                                    padding: '8px 12px',
                                                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                }
                                                            }
                                                        }}
                                                        title={remainingCoordinators?.join(', ')} arrow>
                                                        <TableCell className="dashboardTableBody" sx={{ minWidth: '100px', color: '#52525B' }}>
                                                            {/* {item?.coordinatorData?.map((item) =>
                                                                        item?.coordinatorFirstName
                                                                    )?.join(', ')} */}
                                                            {remainingCoordinators?.length > 0 ? `${twoCoordinators} and ${remainingCoordinators?.length} more` : twoCoordinators}
                                                        </TableCell>
                                                    </Tooltip>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={13}>
                                                <Typography className="emptydatas">No Data Found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13}>
                                        <Box className='tableloader'>
                                            <TableLoader />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )}
                            {Math.ceil(totalCount / rowsPerPage) > 1 && (
                                <TableRow>
                                    <TableCell colSpan={100}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <MUICancelButton
                                                title='Previous'
                                                startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === 1}
                                                onClick={() => handlePageChange(null, page - 1)}
                                                sx={{ height: '36px' }}
                                            />
                                            <Pagination
                                                page={page}
                                                onChange={handlePageChange}
                                                count={Math.ceil(totalCount / rowsPerPage)}
                                                siblingCount={1}
                                                boundaryCount={1}
                                                shape="rounded"
                                                hidePrevButton
                                                hideNextButton
                                            />

                                            <MUICancelButton
                                                title='Next'
                                                startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                                disabled={page === Math.ceil(totalCount / rowsPerPage)}
                                                onClick={() => handlePageChange(null, page + 1)}
                                                sx={{ height: '36px' }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </Table>
                    </Paper>

                    {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    className="tablepagination"
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                    count={totalCount || 0}
                                    rowsPerPageOptions={[10, 20, 50]}
                                />

                            </TableRow>
                        </TableFooter>
                    </Table> */}
                </Grid2>
            </Grid2>

            <ThemeProvider theme={darkTheme}>
                <StyledDialog
                    open={openNew}
                    onClose={() => onOpenChange(false)}
                    scroll="paper"
                    sx={{
                        "& .MuiDialog-paper": {
                            position: 'fixed',
                            right: 0,
                            top: 0,
                            margin: 0,
                            bottom: 0,
                            maxHeight: '100vh',
                            width: '28vw',
                        }
                    }}
                    maxWidth="md" fullWidth>
                    <DialogTitle>
                        <Stack direction="row" justifyContent="space-between">
                            <Box>
                                <Typography variant="h6">Statistics for this Month</Typography>
                            </Box>
                            <X size={20} onClick={() => onOpenChange(false)} style={{ cursor: 'pointer' }} />
                        </Stack>
                    </DialogTitle>

                    <DialogContent sx={{ p: "0 important" }}>
                        <Stack spacing={2}>
                            {metrics.map((m, i) => <StatCard key={m.id} metric={m} index={i} />)}
                        </Stack>

                        <Divider sx={{ my: 3, borderColor: "rgba(71, 85, 105, 0.3)" }} />

                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Typography variant="body2" color="text.secondary">
                                Last updated: {new Date().toLocaleString()}
                            </Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Box
                                    sx={{
                                        width: 8, height: 8, backgroundColor: "#10b981", borderRadius: "50%",
                                        animation: "pulse 2s infinite",
                                        "@keyframes pulse": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.5 } },
                                    }}
                                />
                                <Typography variant="body2" color="text.secondary">Live data</Typography>
                            </Stack>
                        </Stack>
                    </DialogContent>
                </StyledDialog>
            </ThemeProvider>

        </Box>
    )
}

export default Dashboard